import { ElementRef, Input } from '@angular/core';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { COMMA, ENTER} from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ChangeDetectorRef } from '@angular/core';
import { BaseComponent } from 'src/app/base/base.component';
import { PreviewData } from 'src/app/domainObjects/previewData';
import { ConfigService } from 'src/app/services/config/config.service';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { ImportDataViewModel } from 'src/app/viewModels/importDataViewModel';
import { ColumnFilterInfo } from 'src/app/views/previewTable/filterUI/column-filter/column-filter.component';
import { MatSort, Sort } from '@angular/material/sort';
import { SortInfo } from 'src/app/domainObjects/sortInfo';
import { MatMenuTrigger } from '@angular/material/menu';
import { GetFilteredselcolvalsRequest } from 'src/app/messaging/getFilteredselcolvalsRequest';
import { UserDataService } from 'src/app/services/user-data-service';
import { ColumnFilter } from 'src/app/domainObjects/columnFilter';
import { InputPrvwFilterViewModel } from 'src/app/viewModels/inputPrvwFilterViewModel';

export class ErrorResponse {
  errorType?: string;
  errorMessage: string;
}

export interface IPreviewTableDelegate {
  onRefreshClicked(sender: PreviewTableComponent): Promise<void>;

  // Allows delegate to update data after changing page and return the total rows
  onPageChanged(sender: PreviewTableComponent, totalRows: number, pageSize: number, pageIndex: number): Promise<number>;

  onShowFilter(sender: PreviewTableComponent, columnName: string): Promise<void>;

  onApplyFilter(sender: PreviewTableComponent, filterSet: ColumnFilterInfo[], info: ColumnFilterInfo): Promise<void>;

  onClearFilter(sender: PreviewTableComponent, filterSet: ColumnFilterInfo[], columnName: string): void;

  onApplySort(sender: PreviewTableComponent, sortData: SortInfo[]): Promise<void>;

  onClearAllSortFilter(sender: PreviewTableComponent): void;

  // Customize individual row based on data.
  getClassForRow(sender: PreviewTableComponent, row: any, colInfo: ColumnInfo, columns: ColumnInfo[]): string;
}

export class ColumnInfo {
  index: number;
  name: string;
  pydataType: string;
  alternateName?: string;
  filterValues?: any[];
  filterActive?: boolean;
  selectedPartitionedColumn?: string = "";
  width?: string;
  fixedWidth?: boolean;

  constructor(index: number, name: string, pydataType: string, altName?: string, filterValues?: any[], active?: boolean, selectedPartitionedColumn?: string) {
    this.index = index;
    this.name = name;
    this.pydataType = pydataType;
    this.alternateName = altName;
    this.filterValues = filterValues;
    this.filterActive = active;
    this.selectedPartitionedColumn = selectedPartitionedColumn;
  }
}

@Component({
    selector: 'app-preview-table',
    templateUrl: './preview-table.component.html',
    styleUrls: ['./preview-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [],
    standalone: false
})
export class PreviewTableComponent extends BaseComponent implements OnInit {
  @Input() viewModel: ImportDataViewModel;
  @Input() inputPrvwViewModel: InputPrvwFilterViewModel;
  @Input() public hideRefresh = false;
  @Input() public hideOptions = false;
  @Input() public widthOptions = false;
  @Input() public showDataTypes = true;
  @Input() public delegate?: IPreviewTableDelegate = null;

  @Input() public previewType = "";
  @Input() public previewTypeName = "";

  @ViewChild(MatProgressBar) progressBar: MatProgressBar | undefined;

  noDataTitle = 'No Preview Data';
  dataSource: MatTableDataSource<any>;
  displayedColumnInfos?: ColumnInfo[];
  displayedColumns: string[];
  filterValues: any[] = [];
  filteredColumnVals: ColumnFilter[] = [];
  displayedSourceColumns: string[];
  isGettingData = new BehaviorSubject(false);
  maxRows?: number;
  totalRows = 1000;
  rowsPerPage = 10;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 25, 50, 100];
  isPageChanged = false;
  isSortApplied = false;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  activeColumnFilters = [];
  activeFilterSet: ColumnFilterInfo[];
  activeSortsSet: SortInfo[]=[];
  activeSortsSetString: string="";
  selectedRowIndex: number = -1;
  selectedRows: Set<number> = new Set<number>();
  columnFilterValues: any[] = [];
  cacheFileCreationDtTime: string='';

  filterFormControl = new UntypedFormControl();

  @ViewChild('filterInput') filterInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  @ViewChild('topPaginator') topPaginator: MatPaginator;
  @ViewChild('bottomPaginator') bottomPaginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  constructor(private mapperService: ConfigService,
              errorService: ErrorReportingService,
              matDialog: MatDialog,
              private configService: ConfigService,
              private userData: UserDataService,
              private cdRef: ChangeDetectorRef) {
    super(errorService, matDialog);
  }
  public initialPage: Object;
  async ngOnInit(): Promise<void> {
      this.isPageChanged = false;
      this.isSortApplied = false;
    // Nothing to do...
    this.initialPage = { pageSizes: true, pageCount: 8,pageSize: 5, pageSizeList: [5,10,15,25,50,1000] };
  }
  menuTrigger: MatMenuTrigger=null;
  showFilter(menuTrigger: MatMenuTrigger, selectedColName: string): void {
    this.menuTrigger=menuTrigger;
    this.menuTrigger.closeMenu();
    
    this.delegate?.onShowFilter(this, selectedColName);
    // if(this.activeColumnFilters.length == 0) {
    //   this.delegate?.onShowFilter(this, selectedColName);
    // } else {
    //   if (!this.filteredColumnVals) {
    //     this.filteredColumnVals = [];
    //   }
    //   const filteredValues = this.filteredColumnVals.filter( x => {
    //     return x.field === selectedColName;
    //   })[0]?.values
    //   this.filterValues = [];
    //   this.filterValues = filteredValues;
    //   this.menuTrigger.openMenu(); 
    // }
  }

  async fetchselectedcolsvalsfrmAPI(request: GetFilteredselcolvalsRequest){
    const response = await this.configService.getFilteredvalsselectdcolAsync(request);
    this.filterValues = response.data.values;
    if(this.filterValues.length > 0) {
      this.columnFilterValues=this.activeFilterSet?.filter( x => {
        return x.columnName === request.columnName;
      })[0]?.values?? [];
      this.cdRef.detectChanges(); // Force change detection
      this.menuTrigger.openMenu();
    } else {
      this.menuTrigger.closeMenu();
      this.displayWarning(response.errorMsg,"Column Filtering Warning");
    }
  }

  applyStackFilters(selectedColNameToFilter: string){
    if(this.filteredColumnVals?.length > 0) {
      this.filterValues = [];
      this.columnFilterValues=this.filteredColumnVals?.filter( x => {
        return x.field === selectedColNameToFilter;
      })[0]?.values?? [];
      this.filterValues.push(...this.columnFilterValues);
      this.cdRef.detectChanges(); // Force change detection
      this.menuTrigger.openMenu();
    } else {
      this.menuTrigger.closeMenu();
      this.displayWarning(selectedColNameToFilter+" column doesn't have any values, so unable to fetch values of the "+ selectedColNameToFilter +" column.", "Column Filtering Warning")
    }
  }

  removeFilter(filter: string): void {
    const index = this.activeColumnFilters.indexOf(filter);
    if (!this.activeFilterSet) {
      this.activeFilterSet = [];
    }
    if (index >= 0) {
      this.activeColumnFilters.splice(index, 1);
    }

    // remove existing filter by columnName
    this.activeFilterSet = this.activeFilterSet.filter(f => f.columnName !== filter);
  }

  addFilter(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our filter
    if ((value || '').trim()) {
      this.activeColumnFilters.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.filterFormControl.setValue(null);
  }

  onFilterSelected(event: MatAutocompleteSelectedEvent): void {
    this.activeColumnFilters.push(event.option.viewValue);
    this.filterInput.nativeElement.value = '';
    this.filterFormControl.setValue(null);
  }

  // Used for the template to re-render when using index based columns within ngFor
  // https://github.com/angular/components/issues/8361#issuecomment-345804954
  trackByIndex = i => i;

  clear(): void {
    this.isGettingData.next(false);
    this.dataSource = null;
    this.totalRows = 0;
    this.cacheFileCreationDtTime='';
  }

  /** Connect sort and paginator for client-side operation (Copilot analysis tables). */
  connectClientSideControls(): void {
    if (this.dataSource) {
      this.dataSource.sort      = this.sort;
      this.dataSource.paginator = this.topPaginator;
    }
  }

  /** Populate the filter dropdown from in-memory data and open the menu (client-side only). */
  setClientFilterValues(columnName: string, allValues: any[]): void {
    this.filterValues = allValues;
    this.columnFilterValues = this.activeFilterSet?.find(f => f.columnName === columnName)?.values ?? [];
    this.cdRef.detectChanges();
    this.menuTrigger.openMenu();
  }

  /** Set column widths on displayedColumnInfos (client-side Copilot tables). */
  setColumnWidths(widths: { [index: number]: { width: string; fixed: boolean } }): void {
    this.displayedColumnInfos?.forEach(col => {
      const w = widths[col.index];
      if (w) {
        col.width      = w.width;
        col.fixedWidth = w.fixed;
      }
    });
    this.cdRef.detectChanges();
  }

  /** Re-evaluate MatTableDataSource filter against activeFilterSet (client-side only). */
  applyClientFilter(): void {
    if (!this.dataSource) return;
    this.dataSource.filterPredicate = (row: any, _filter: string): boolean => {
      if (!this.activeFilterSet?.length) return true;
      return this.activeFilterSet.every(fi => {
        const col = this.displayedColumnInfos?.find(c => c.name === fi.columnName);
        return col ? fi.values.map(String).includes(String(row[col.index])) : true;
      });
    };
    this.dataSource.filter = this.activeFilterSet?.length ? 'active' : '';
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.cdRef.detectChanges();
  }

  async bindData(previewData: PreviewData, emptyResultText: string, selectedPartitionedColumn: string = ""): Promise<void> {
    try {
      this.noDataTitle = emptyResultText;
      //Clear Filters, Sort if Run Transformer button is clicked manually
      if(this.userData.getToClearActiveFilters() && this.isPageChanged == false && this.isSortApplied == false) {
        this.activeColumnFilters = [];
        this.activeFilterSet = [];
        this.displayedColumns = [];
        this.activeSortsSet = [];
        this.activeSortsSetString = "";
      }
      this.dataSource = new MatTableDataSource<any>();
      this.dataSource.data = Object.values(previewData.rows);
      this.totalRows = previewData.totalRows;
      this.cacheFileCreationDtTime = previewData.cacheFileCreationDtTime;
      this.displayedColumnInfos = previewData.columns
        .filter(colDef => colDef.columnName)
        .map(colDef => new ColumnInfo(
          colDef.index,
          colDef.columnName,
          colDef.pyDataType,
          null,
          null,
          this.activeColumnFilters.filter(f => f === colDef.columnName).length > 0,
          selectedPartitionedColumn));
      
      this.displayedColumns = this.displayedColumnInfos.map(info => info.index.toString());
      
      this.filteredColumnVals = previewData.filterInfo;
      this.isPageChanged = false;
      this.isSortApplied = false;

      this.cdRef.detectChanges();
      //this.dataSource.sort = this.sort;
    } catch (err) {
      //this.isGettingData.next(false);
      this.displayError('Failed to preview data.', 'Error', err);
    }
  }

  async onRefreshClicked(): Promise<void> {
    await this.delegate?.onRefreshClicked(this);
  }

  async previewData(): Promise<void> {
    this.isGettingData.next(true);
  }

  onPageChanged(event: PageEvent, sender: MatPaginator): void {
    this.totalRows = event.length;
    this.rowsPerPage = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.isPageChanged = true;
    if (sender === this.topPaginator) {
      this.bottomPaginator.pageIndex = this.pageIndex;
    } else {
      this.topPaginator.pageIndex = this.pageIndex;
    }
    this.delegate?.onPageChanged(this, this.totalRows, this.rowsPerPage, this.pageIndex);
  }

  getClassForRow(rowItem: any, column: ColumnInfo, colInfos: ColumnInfo[]): string {
    return this.delegate?.getClassForRow(this, rowItem, column, colInfos);
  }

  onApplyFilter(info: ColumnFilterInfo): void {
    this.userData.setApplyFilterBtnClicked(true);
    this.userData.setToClearActiveFilters(false);
    this.displayedColumnInfos.filter(c => c.name === info.columnName)[0].filterActive = true;
    
    if (this.activeColumnFilters.filter(f => f === info.columnName).length === 0) {
      this.activeColumnFilters.push(info.columnName);
    }

    if (!this.activeFilterSet) {
      this.activeFilterSet = [];
    }

    // remove existing filter by columnName
    this.activeFilterSet = this.activeFilterSet.filter(f => f.columnName !== info.columnName);

    // add new filter to active set
    this.activeFilterSet.push(info);

    this.delegate?.onApplyFilter(this, this.activeFilterSet, info);
    this.menuTrigger.closeMenu();
  }

  onClearFilter(colName: string): void {
    this.displayedColumnInfos.filter(c => c.name === colName)[0].filterActive = false;
    this.removeFilter(colName);
    this.delegate?.onClearFilter(this, this.activeFilterSet, colName);
    this.menuTrigger.closeMenu();
  }

  onCloseFilter(): void {
    this.menuTrigger.closeMenu();
  }
  
  async sortData(property: string) {
    const busyIndicator = this.showBusyDialog('Sorting Data...');
    this.isSortApplied = true;
    if(property!='row'){
      if (!this.activeSortsSet) {
        this.activeSortsSet = [];
      }else{
        //sort as prev
        this.activeSortsSet.reverse();
      }
      const index = this.activeSortsSet.findIndex(item => item.sortField === property);
      if (index > -1) {
        if(this.sortState=='asc'){
          this.activeSortsSet[index].sortAscending = true;
        }else if(this.sortState=='desc'){
          this.activeSortsSet[index].sortAscending = false;
        }
        else{
          // If sorting state is neither 'asc' nor 'desc', remove the item from the array
          //this.activeSortsSet.splice(index, 1);
        }
        //put it in first sort
        const [item] = this.activeSortsSet.splice(index, 1);
        this.activeSortsSet.push(item);
        
      } else {
        this.activeSortsSet.push({ sortField:property,sortAscending:true });
      }
        
      //sort order
      this.activeSortsSet.reverse();
      //this.applySorts.emit(this.activeSortsSet);
      this.delegate?.onApplySort(this,this.activeSortsSet);
      //this.onRefreshClicked();
      await this.delegate?.onRefreshClicked(this);
      this.activeSortsSetString=this.convertJsonToString(this.activeSortsSet);
    }
    //setInterval(() => {
      busyIndicator.close();
    //}, 500);
  }
  convertJsonToString(jsonArray) {
    // Create an array to hold the result parts
    const resultParts = [];

    // Iterate through each object in the JSON array
    for (const item of jsonArray) {
        // Determine the arrow symbol based on sortAscending
        const arrow = item.sortAscending ? '⭡' : '⭣';

        // Construct the string for this item
        const part = `${item.sortField} ${arrow}`;

        // Add the constructed part to the resultParts array
        resultParts.push(part);
    }

    // Join all parts using " -> " as a separator
    const resultString = resultParts.join(' -> ');

    // Return the final string
    return resultString;
}
  sortState:string="";
  announceSortChange(sortState: Sort) {
    if (sortState.direction) {
      this.sortState=sortState.direction;
    } else {
      this.sortState='cleared';
    }
  }
  async clearSortFilter(){
    const busyIndicator = this.showBusyDialog('Clear Sorting and Filter Data...');
    // Reset the sorting state
    this.sort.active = '';
    this.sort.direction = '';
    // Notify dataSource of the changes
    this.dataSource.sort = this.sort;
    this.activeSortsSet=[];
    //clear filter
    this.displayedColumnInfos.forEach(x=>{
      x.filterActive=false;
    });
    
    this.activeColumnFilters=[];
    this.activeFilterSet=[];
    //this.clearAllSortFilter.emit();
    this.delegate?.onClearAllSortFilter(this);
    const excludedTypes = ["Summary"];
    if(!excludedTypes.includes(this.previewType)){
      await this.delegate?.onRefreshClicked(this);
    }
    busyIndicator.close();
  }

  highlightRow(index: number, event: MouseEvent): void {
    if (event.ctrlKey || event.metaKey) { // Check if ctrl or cmd key is pressed
      if (this.selectedRows.has(index)) {
        this.selectedRows.delete(index);
      } else {
        this.selectedRows.add(index);
      }
    } else {
      this.selectedRows.clear();
      this.selectedRows.add(index);
    }
  }

  isRowSelected(index: number): boolean {
    return this.selectedRows.has(index);
  }

  resetPreview(): void {
    this.isGettingData.next(false);
    this.dataSource = null;
    this.totalRows = 0;
    this.cacheFileCreationDtTime='';
    this.cdRef.detectChanges();
  }

  // Clears bound data plus any active sort/filter state, without re-fetching — used when
  // switching to a different Ingest Farm so stale data/sort/filter from the previous
  // selection never lingers on screen until the Analyst explicitly clicks Refresh Preview.
  resetPreviewAndFilters(): void {
    this.resetPreview();
    if (this.sort) {
      this.sort.active = '';
      this.sort.direction = '';
    }
    this.activeSortsSet = [];
    this.activeSortsSetString = '';
    this.displayedColumnInfos?.forEach(x => { x.filterActive = false; });
    this.activeColumnFilters = [];
    this.activeFilterSet = [];
    this.displayedColumns = [];
  }




}
